import { render, staticRenderFns } from "./GiveAndAsk.vue?vue&type=template&id=11b83bf5&"
import script from "./GiveAndAsk.vue?vue&type=script&lang=js&"
export * from "./GiveAndAsk.vue?vue&type=script&lang=js&"
import style0 from "./GiveAndAsk.vue?vue&type=style&index=0&id=11b83bf5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports